<template>
  <v-toolbar dense flat class="minitoolbar">
    <slot name="toolbar-content">

      <slot name="toolbar-content-left" />

      <SorterMenu v-model="sortedlist" :pk="pk" :inputlist="searchedlist" :fieldlist="sortablefields" />

      <FilterMenu v-model="filteredlist" :pk="pk" :inputlist="inputlist" :fieldlist="filterablefields" />

      <FilterSearchbar v-model="searchedlist" :pk="pk" :inputlist="filteredlist" class="ml-2 mb-1" />

      <slot name="toolbar-content-center-left" />

      <v-spacer />

      <slot name="toolbar-content-center" />

      <v-spacer />
      <slot name="toolbar-content-center-right" />

      <DifferenceIndicator :overridecount="overridecount" :fulllist="inputlist" :reducedlist="outputlist"
        :objectName="objectName" />

      <slot name="toolbar-content-right" />
    </slot>
  </v-toolbar>
</template>


<script>
import SorterMenu from "@/components/Menus/SorterMenu.vue";
import FilterMenu from "@/components/Menus/FilterMenu.vue";
import FilterSearchbar from "@/views/admin/machines/FilterSearchbar.vue";
import DifferenceIndicator from "@/views/admin/machines/DifferenceIndicator.vue";

export default {
  name: "ListToolbar",
  model: {
    prop: "outputlist",
    event: "change",
  },
  props: {
    pk: String,
    outputlist: Array,
    inputlist: Array,
    objectName: String,
    sortablefields: Array,
    filterablefields: Array,
    overridecount: Number,
  },
  components: {
    SorterMenu,
    FilterMenu,
    FilterSearchbar,
    DifferenceIndicator,
  },
  mixins: [],

  data() {
    return {
      filteredlist: [],
      searchedlist: [],
      sortedlist: [],
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {
    /*filteredlist: function (newval) {

    },*/

    /*searchedlist: function (newval) {

    },*/

    sortedlist: function (newval) {

      this.$emit("change", newval);
    },
  },
};
</script>


<style lang='scss' scoped>
.minitoolbar {
  position: sticky;
  width: 100%;
  z-index: 4;
  //box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}
</style>